import { Action } from 'redux';

export const RELOAD_HEADER = 'RELOAD_HEADER';
export type ReloadHeaderAction = Action<typeof RELOAD_HEADER>;

export const RELOAD_HEADER_SUCCESS = 'RELOAD_HEADER_SUCCESS';
export type ReloadHeaderSuccessAction = Action<typeof RELOAD_HEADER_SUCCESS>;

export const SET_STICKY_MODE = 'SET_STICKY_MODE';
export type SetStickyModeAction = {
    type: typeof SET_STICKY_MODE;
    payload: boolean;
};

export const ACTIVE_VIEW_CATALOGUE = 'ACTIVE_VIEW_CATALOGUE';
export type ActiveViewCatalogueAction = Action<typeof ACTIVE_VIEW_CATALOGUE>;

export const ACTIVE_VIEW_BY_PRODUCT_TYPE = 'ACTIVE_VIEW_BY_PRODUCT_TYPE';
export type ActiveViewByProductTypeAction = Action<typeof ACTIVE_VIEW_BY_PRODUCT_TYPE>;

export const ACTIVE_VIEW_RESERVE_LIST = 'ACTIVE_VIEW_RESERVE_LIST';
export type ActiveViewReserveListAction = Action<typeof ACTIVE_VIEW_RESERVE_LIST>;

export const ACTIVE_VIEW_RESERVE_DETAIL = 'ACTIVE_VIEW_RESERVE_DETAIL';
export type ActiveViewReserveDetailAction = Action<typeof ACTIVE_VIEW_RESERVE_DETAIL>;

export const ACTIVE_VIEW_RESERVE_CHECKOUT = 'ACTIVE_VIEW_RESERVE_CHECKOUT';
export type ActiveViewReserveCheckoutAction = Action<typeof ACTIVE_VIEW_RESERVE_CHECKOUT>;

export const ACTIVE_VIEW_CHECKOUT = 'ACTIVE_VIEW_CHECKOUT';
export type ActiveViewCheckoutAction = Action<typeof ACTIVE_VIEW_CHECKOUT>;

export const ACTIVE_VIEW_CHECKOUT_THANKS = 'ACTIVE_VIEW_CHECKOUT_THANKS';
export type ActiveViewCheckoutThanksAction = Action<typeof ACTIVE_VIEW_CHECKOUT_THANKS>;

export const ACTIVE_VIEW_SELECTIONLIST = 'ACTIVE_VIEW_SELECTIONLIST';
export type ActiveViewSelectionlistAction = Action<typeof ACTIVE_VIEW_SELECTIONLIST>;

export const ACTIVE_VIEW_CART = 'ACTIVE_VIEW_CART';
export type ActiveViewCartAction = Action<typeof ACTIVE_VIEW_CART>;

export const ACTIVE_VIEW_ORDERS = 'ACTIVE_VIEW_ORDERS';
export type ActiveViewOrdersAction = Action<typeof ACTIVE_VIEW_ORDERS>;

export const ACTIVE_VIEW_ORDERS_DETAIL = 'ACTIVE_VIEW_ORDERS_DETAIL';
export type ActiveViewOrdersDetailAction = Action<typeof ACTIVE_VIEW_ORDERS_DETAIL>;

export const ACTIVE_VIEW_SEARCH = 'ACTIVE_VIEW_SEARCH';
export type ActiveViewSearchAction = Action<typeof ACTIVE_VIEW_SEARCH>;

export const ACTIVE_VIEW_PRODUCT_DETAIL = 'ACTIVE_VIEW_PRODUCT_DETAIL';
export type ActiveViewProductDetailAction = Action<typeof ACTIVE_VIEW_PRODUCT_DETAIL>;

export const ACTIVE_VIEW_BUNDLE_DETAIL = 'ACTIVE_VIEW_BUNDLE_DETAIL';
export type ActiveViewBundleDetailAction = Action<typeof ACTIVE_VIEW_BUNDLE_DETAIL>;

export const ACTIVE_VIEW_BUNDLE_LIST = 'ACTIVE_VIEW_BUNDLE_LIST';
export type ActiveViewBundleListAction = Action<typeof ACTIVE_VIEW_BUNDLE_LIST>;

export const ACTIVE_VIEW_ORDER_ASSISTANT = 'ACTIVE_VIEW_ORDER_ASSISTANT';
export type ActiveViewOrderAssistantAction = Action<typeof ACTIVE_VIEW_ORDER_ASSISTANT>;

export const ACTIVE_VIEW_INCOMPLETE_SERIES = 'ACTIVE_VIEW_INCOMPLETE_SERIES';
export type ActiveViewIncompleteSeriesAction = Action<typeof ACTIVE_VIEW_INCOMPLETE_SERIES>;

export const ACTIVE_VIEW_COMPLETE_COLLECTION = 'ACTIVE_VIEW_COMPLETE_COLLECTION';
export type ActiveViewCompleteCollectionAction = Action<typeof ACTIVE_VIEW_COMPLETE_COLLECTION>;

export const ACTIVE_VIEW_NEWLY_ADDED = 'ACTIVE_VIEW_NEWLY_ADDED';
export type ActiveViewNewlyAddedAction = Action<typeof ACTIVE_VIEW_NEWLY_ADDED>;

export const ACTIVE_VIEW_BY_GENRE = 'ACTIVE_VIEW_BY_GENRE';
export type ActiveViewByGenreAction = Action<typeof ACTIVE_VIEW_BY_GENRE>;

export const ACTIVE_VIEW_COLLECTION_SEARCH = 'ACTIVE_VIEW_COLLECTION_SEARCH';
export type ActiveViewCollectionSearchAction = Action<typeof ACTIVE_VIEW_COLLECTION_SEARCH>;

export const ACTIVE_VIEW_LOCAL_CONTENT_PRODUCTS = 'ACTIVE_VIEW_LOCAL_CONTENT_PRODUCTS';
export type ActiveViewLocalContentProductsAction = Action<typeof ACTIVE_VIEW_LOCAL_CONTENT_PRODUCTS>;

export const ACTIVE_VIEW_LOCAL_CONTENT_COLLECTION = 'ACTIVE_VIEW_LOCAL_CONTENT_COLLECTION';
export type ActiveViewLocalContentCollectionAction = Action<typeof ACTIVE_VIEW_LOCAL_CONTENT_COLLECTION>;

export const ACTIVE_VIEW_LOCAL_CONTENT_PRODUCT_DETAILS = 'ACTIVE_VIEW_LOCAL_CONTENT_PRODUCT_DETAILS';
export type ActiveViewLocalContentProductDetailsAction = Action<typeof ACTIVE_VIEW_LOCAL_CONTENT_PRODUCT_DETAILS>;

export const ACTIVE_VIEW_LOCAL_CONTENT_AUTHORS = 'ACTIVE_VIEW_LOCAL_CONTENT_AUTHORS';
export type ActiveViewLocalContentAuthorsAction = Action<typeof ACTIVE_VIEW_LOCAL_CONTENT_AUTHORS>;

export const ACTIVE_VIEW_LIBX_PRODUCT_DETAIL = 'ACTIVE_VIEW_LIBX_PRODUCT_DETAIL';
export type ActiveViewLibxProductDetailAction = Action<typeof ACTIVE_VIEW_LIBX_PRODUCT_DETAIL>;

export const ACTIVE_VIEW_TERMS_AND_CONDITIONS = 'ACTIVE_VIEW_TERMS_AND_CONDITIONS';
export type ActiveViewTermsAndConditionsAction = Action<typeof ACTIVE_VIEW_TERMS_AND_CONDITIONS>;

export const ACTIVE_VIEW_LIBX_FEATURED = 'ACTIVE_VIEW_LIBX_FEATURED';
export type ActiveViewLibxFeaturedAction = Action<typeof ACTIVE_VIEW_LIBX_FEATURED>;

export const ACTIVE_VIEW_LIBX_NEWLY_ADDED = 'ACTIVE_VIEW_LIBX_NEWLY_ADDED';
export type ActiveViewLibxNewlyAddedAction = Action<typeof ACTIVE_VIEW_LIBX_NEWLY_ADDED>;

export const ACTIVE_VIEW_LIBX_ALL_TITLES = 'ACTIVE_VIEW_LIBX_ALL_TITLES';
export type ActiveViewLibxAllTitlesAction = Action<typeof ACTIVE_VIEW_LIBX_ALL_TITLES>;

export const ACTIVE_VIEW_LIBX_GENRES = 'ACTIVE_VIEW_LIBX_GENRES';
export type ActiveViewLibxGenresAction = Action<typeof ACTIVE_VIEW_LIBX_GENRES>;

export const ACTIVE_VIEW_LIBX_REGIONS = 'ACTIVE_VIEW_LIBX_REGIONS';
export type ActiveViewLibxRegionsAction = Action<typeof ACTIVE_VIEW_LIBX_REGIONS>;

export const ACTIVE_VIEW_LOTE = 'ACTIVE_VIEW_LOTE';
export type ActiveViewLoteAction = Action<typeof ACTIVE_VIEW_LOTE>;

export const ACTIVE_VIEW_LOTE_FEATURED = 'ACTIVE_VIEW_LOTE_FEATUERD';
export type ActiveViewLoteFeaturedAction = Action<typeof ACTIVE_VIEW_LOTE_FEATURED>;

export const ACTIVE_VIEW_LOTE_NEWLYADDED = 'ACTIVE_VIEW_LOTE_NEWLYADDED';
export type ActiveViewLoteNewlyaddedAction = Action<typeof ACTIVE_VIEW_LOTE_NEWLYADDED>;

export const ACTIVE_VIEW_LOTE_GENRES = 'ACTIVE_VIEW_LOTE_GENRES';
export type ActiveViewLoteGenresAction = Action<typeof ACTIVE_VIEW_LOTE_GENRES>;

export const ACTIVE_VIEW_LOTE_PRODUCTS = 'ACTIVE_VIEW_LOTE_PRODUCTS';
export type ActiveViewLoteProductsAction = Action<typeof ACTIVE_VIEW_LOTE_PRODUCTS>;

export const ACTIVE_VIEW_LANGUAGELEARNING = 'ACTIVE_VIEW_LANGUAGELEARNING';
export type ActiveViewLanguagelearningAction = Action<typeof ACTIVE_VIEW_LANGUAGELEARNING>;

export const ACTIVE_VIEW_LANGUAGELEARNING_FEATURED = 'ACTIVE_VIEW_LANGUAGELEARNING_FEATURED';
export type ActiveViewLanguagelearningFeaturedAction = Action<typeof ACTIVE_VIEW_LANGUAGELEARNING_FEATURED>;

export const ACTIVE_VIEW_LANGUAGELEARNING_NEWLYADDED = 'ACTIVE_VIEW_LANGUAGELEARNING_NEWLYADDED';
export type ActiveViewLanguagelearningNewlyaddedAction = Action<typeof ACTIVE_VIEW_LANGUAGELEARNING_NEWLYADDED>;

export const ACTIVE_VIEW_LANGUAGELEARNING_PRODUCTS = 'ACTIVE_VIEW_LANGUAGELEARNING_PRODUCTS';
export type ActiveViewLanguagelearningProductsAction = Action<typeof ACTIVE_VIEW_LANGUAGELEARNING_PRODUCTS>;

export const ACTIVE_VIEW_FOREIGNLANGUAGE_BUNDLES = 'ACTIVE_VIEW_FOREIGNLANGUAGE_BUNDLES';
export type ActiveViewForeignlanguageBundlesAction = Action<typeof ACTIVE_VIEW_FOREIGNLANGUAGE_BUNDLES>;

export const ACTIVE_VIEW_CAMPAIGNS = 'ACTIVE_VIEW_CAMPAIGNS';
export type ActiveViewCampaignsAction = Action<typeof ACTIVE_VIEW_CAMPAIGNS>;

export const ACTIVE_VIEW_UNLIMITED = 'ACTIVE_VIEW_UNLIMTED';
export type ActiveViewUnlimitedAction = Action<typeof ACTIVE_VIEW_UNLIMITED>;

export const ACTIVE_VIEW_MARKETING_CAMPAIGNS = 'ACTIVE_VIEW_MARKETING_CAMPAIGNS';
export type ActiveViewMarketingCampaignsAction = Action<typeof ACTIVE_VIEW_MARKETING_CAMPAIGNS>;

export const ACTIVE_VIEW_LIBRARY_MANAGED_PRODUCT_GROUPS = 'ACTIVE_VIEW_LIBRARY_MANAGED_PRODUCT_GROUPS';
export type ActiveViewLibraryManagedProductGroupsAction = Action<typeof ACTIVE_VIEW_LIBRARY_MANAGED_PRODUCT_GROUPS>;

export const ACTIVE_VIEW_LIBRARY_MANAGED_PRODUCT_GROUP = 'ACTIVE_VIEW_LIBRARY_MANAGED_PRODUCT_GROUP';
export type ActiveViewLibraryManagedProductGroupAction = Action<typeof ACTIVE_VIEW_LIBRARY_MANAGED_PRODUCT_GROUP>;

export type HeaderAction =
    | ReloadHeaderAction
    | ReloadHeaderSuccessAction
    | SetStickyModeAction
    | ActiveViewCatalogueAction
    | ActiveViewByProductTypeAction
    | ActiveViewReserveListAction
    | ActiveViewReserveDetailAction
    | ActiveViewReserveCheckoutAction
    | ActiveViewCheckoutAction
    | ActiveViewCheckoutThanksAction
    | ActiveViewSelectionlistAction
    | ActiveViewCartAction
    | ActiveViewOrdersAction
    | ActiveViewOrdersDetailAction
    | ActiveViewSearchAction
    | ActiveViewProductDetailAction
    | ActiveViewBundleDetailAction
    | ActiveViewBundleListAction
    | ActiveViewOrderAssistantAction
    | ActiveViewIncompleteSeriesAction
    | ActiveViewCompleteCollectionAction
    | ActiveViewNewlyAddedAction
    | ActiveViewByGenreAction
    | ActiveViewCollectionSearchAction
    | ActiveViewLocalContentProductsAction
    | ActiveViewLocalContentCollectionAction
    | ActiveViewLocalContentProductDetailsAction
    | ActiveViewLocalContentAuthorsAction
    | ActiveViewLibxProductDetailAction
    | ActiveViewTermsAndConditionsAction
    | ActiveViewLibxFeaturedAction
    | ActiveViewLibxNewlyAddedAction
    | ActiveViewLibxAllTitlesAction
    | ActiveViewLibxGenresAction
    | ActiveViewLibxRegionsAction
    | ActiveViewLoteAction
    | ActiveViewLoteFeaturedAction
    | ActiveViewLoteNewlyaddedAction
    | ActiveViewLoteGenresAction
    | ActiveViewLoteProductsAction
    | ActiveViewLanguagelearningAction
    | ActiveViewLanguagelearningFeaturedAction
    | ActiveViewLanguagelearningNewlyaddedAction
    | ActiveViewLanguagelearningProductsAction
    | ActiveViewForeignlanguageBundlesAction
    | ActiveViewCampaignsAction
    | ActiveViewUnlimitedAction
    | ActiveViewMarketingCampaignsAction
    | ActiveViewLibraryManagedProductGroupsAction
    | ActiveViewLibraryManagedProductGroupAction;
